export default __webpack_public_path__ + "static/media/step_02.a8aa6900.png";